import { createContext } from 'react';
import { MainContextProps } from '@interfaces/interfaces';

export const MainContext = createContext<MainContextProps>(
  {} as MainContextProps
);
